module.exports = __webpack_public_path__ + "media/images/riders/small/FINN_ILES-2e86c4cd8131bd7de0959a45ea48671c.png";